export const SKIN = 'SKIN'
export const TOKEN = 'TOKEN'
export const MENUACTIVENAME = 'MENUACTIVENAME'
export const MENUOPENNAME = 'MENUOPENNAME'
export const PAGE_SIZE = 'PAGE_SIZE'
export const MODEL_DISABLED = 'MODEL_DISABLED'
export const CRUMBS_LIST = 'CRUMBS_LIST'
export const MENU_LIST = 'MENU_LIST'
export const BIND_PHONE = 'BIND_PHONE'


// WEBPACK FOOTER //
// ./src/store/mutation-types.js